/**
 * Глобальний хелпер для підстановки префікса папки шаблону до шляхів файлів у TS
 */
export function asset(url: string): string {
    if (!url) return '';

    // Якщо шлях уже абсолютний або починається зі слешу, повертаємо як є
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) {
        return url;
    }

    // Зчитуємо префікс із window
    const prefix = (window as any).configuratorPrefix || '';

    return prefix + url;
}